export enum TrainingAudience {

    A = "All",
    C = "Civilians",
    P = "Police",
    M = "Military"

}